import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { ApiStatics } from '../../Config/Static';
import ModalSuccessImg from '../../Assets/modal_success.svg';
import axios from 'axios';
import download from 'js-file-download';

const initialState = {
  items: {},
  razorpayOrderDetails: {},
  coupons: [],
  currentSummary: 0,
  razorpayOrderTime: null,
  orderComplete: false,
  orderDetails: null,
  downloadTicketLoading: false,
  isFreeEvent: false,
  couponApplied: false,
  couponDiscount: 0,
  couponId: null,
  couponCode: null,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    clearCart(state) {
      const currentState = current(state);
      const tickets = [];
      currentState.items.tickets.forEach((ticket) => {
        tickets.push({ ...ticket, selectedQuantity: 0 });
      });
      state.items.tickets = tickets;
      state.currentSummary = 0;
      state.orderComplete = false;
      state.orderDetails = null;
    },
    clearRazorpayItems(state) {
      state.razorpayOrderDetails = {};
      state.razorpayOrderTime = null;
      state.orderComplete = false;
      state.couponApplied = false;
      state.couponDiscount = 0;
      state.couponId = null;
      state.couponCode = null;
    },
    addCoupon(state, { payload }) {
      state.couponCode = payload.code;
      state.couponId = payload.id;
      state.couponDiscount = payload.discount;
    },
    removeCoupon(state, { payload }) {
      state.couponId = null;
      state.couponDiscount = null;
      state.couponCode = null;
      state.couponApplied = false;
    },
    nextSummary(state, { payload }) {
      if (state.currentSummary <= 1) {
        state.currentSummary += 1;
      }
    },
    previousSummary(state, { payload }) {
      if (state.currentSummary > 0) {
        state.currentSummary -= 1;
      }
    },
    resetSummary(state, { payload }) {
      state.currentSummary = 0;
    },
    addItem(state, action) {
      const newItem = action.payload;
      state.currentSummary = 0;
      state.items = { ...newItem, selectedQuantity: 1 };
    },
    incrementItem(state, action) {
      const itemId = action.payload;
      const temp = [...state.items.tickets];
      const itemIndex = temp.findIndex((item) => item.id === itemId);
      if (!temp[itemIndex].selectedQuantity) {
        temp[itemIndex].selectedQuantity = 0;
      }

      if (itemIndex >= 0) {
        temp[itemIndex].selectedQuantity += 1;
      }
      state.items.tickets = temp;
    },
    decrementItem(state, action) {
      const itemId = action.payload;
      const temp = [...state.items.tickets];
      const itemIndex = temp.findIndex((item) => item.id === itemId);
      if (itemIndex >= 0 && temp[itemIndex].selectedQuantity > 0) {
        temp[itemIndex].selectedQuantity -= 1;
      }
      state.items.tickets = temp;
    },
    resetCart(state) {
      state.items = [];
    },
    reduceCartItemToZero(state, action) {
      const itemId = action.payload;
      const temp = [...state.items.tickets];
      const itemIndex = temp.findIndex((item) => item.id === itemId);
      if (itemIndex >= 0) {
        temp[itemIndex].selectedQuantity = 0;
      }
      state.items.tickets = temp;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkCouponValidity.pending, (state, action) => {
        state.couponApplied = false;
        state.couponDiscount = 0;
        state.couponId = '';
        state.couponCode = '';
      })
      .addCase(checkCouponValidity.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.couponApplied = true;
          state.couponDiscount = action.payload.data.discountAmount;
          state.couponId = action.payload.data.couponId;
          state.couponCode = action.payload.code;
        } else {
          window.alert(action.payload.error);
        }
      })
      .addCase(downloadBookingTicket.pending, (state, action) => {
        state.downloadTicketLoading = true;
      })
      .addCase(downloadBookingTicket.fulfilled, (state, action) => {
        state.downloadTicketLoading = false;
      })
      .addCase(getAllEventCoupons.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllEventCoupons.fulfilled, (state, action) => {
        state.loading = false;
        state.coupons = action.payload.data;
      })
      .addCase(getAllEventCoupons.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getEventBookingByOrderId.pending, (state, action) => {
        state.loading = true;
        state.error = initialState.error;
      })
      .addCase(getEventBookingByOrderId.fulfilled, (state, action) => {
        console.log('order action', action);
        if (action.payload.data != null) {
          state.orderComplete = true;
          state.orderDetails = action.payload.data;
        }
      })
      .addCase(getRazorPayOrder.pending, (state, action) => {
        state.loading = true;
        state.error = initialState.error;
      })
      .addCase(getRazorPayOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = initialState.error;
      })
      .addCase(getRazorPayOrder.fulfilled, (state, action) => {
        state.razorpayOrderDetails = action.payload.data;
        state.razorpayOrderTime = new Date().getTime();
        state.isFreeEvent = action.payload.isFree;
        state.success = true;
        state.loading = false;
      });
  },
});

export const downloadBookingTicket = createAsyncThunk(
  `cart/downloadBookingTicket`,
  async ({ id }) => {
    try {
      console.log('Downloading: ', id);
      let data = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.events.event}/${ApiStatics.bookings.bookings}/${ApiStatics.bookings.web}/${id}/download`,
        {
          responseType: 'blob',
        }
      );
      download(data.data, `Ticket-${id}.pdf`);
      return {
        success: true,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  }
);

export const getEventBookingByOrderId = createAsyncThunk(
  `cart/getEventBookingByOrderId`,
  async ({ id }) => {
    try {
      console.log(id);
      let data = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.events.event}/${ApiStatics.bookings.bookings}/${ApiStatics.bookings.web}/${id}`
      );
      return {
        success: true,
        data: data.data.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  }
);
export const getAllEventCoupons = createAsyncThunk(
  `cart/getAllEventCoupons`,
  async ({ id }) => {
    try {
      console.log(id);
      let data = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.coupons.coupons}/public?event=${id}`
      );

      return {
        success: true,
        data: data.data.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  }
);

export const getRazorPayOrder = createAsyncThunk(
  `cart/getRazorPayOrder`,
  async ({ id, setOpenModal, setFreeLoading, dispatch, body }) => {
    try {
      let data = await axios.put(
        `${process.env.REACT_APP_API_BACKEND_URL}/${ApiStatics.events.event}/${id}/${ApiStatics.bookings.bookings}/${ApiStatics.bookings.web}`,
        body
      );
      if (body.amount === 0) {
        dispatch(getEventBookingByOrderId({ id: data.data.data.data.id }));
      }
      return {
        success: true,
        data: data.data.data.data,
        isFree: body.amount === 0,
      };
    } catch (error) {
      setFreeLoading(false);
      return {
        success: false,
        error: error.response.data.message,
      };
    }
  }
);

export const checkCouponValidity = createAsyncThunk(
  `cart/checkCouponValidity`,
  async ({ params, code, setCode }) => {
    try {
      let couponEndpoint = ApiStatics.coupons.couponValidity;
      couponEndpoint = couponEndpoint.replace(':code', code);
      let data = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/${couponEndpoint}`,
        {
          params,
        }
      );
      if (!data.success) setCode && setCode('');
      // setCode && setCode("");
      return {
        success: true,
        data: data.data.data,
        code: code,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response.data.message,
      };
    }
  }
);

export const {
  addItem,
  incrementItem,
  decrementItem,
  resetCart,
  clearRazorpayItems,
  reduceCartItemToZero,
  nextSummary,
  previousSummary,
  resetSummary,
  clearCart,
  addCoupon,
  removeCoupon,
} = cartSlice.actions;
export default cartSlice.reducer;
